<template>
    <Chart type="donut" :chartdata="data" :options="options"></Chart>
</template>
<script>
import db from '@/components/firebase.init'
import Chart from '@/components/charts/Charts'
export default {
    data(){
        return{
             company_id: this.$route.params.companyId,
            options: {
                             plugins: {
		datalabels: {
			display: true
		}
	     },
 tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                },
                animation: {
                easing: 'easeOutBounce',
                numSteps: '100',
                },
                hover: {
                    animationDuration: '1',
                },
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },
            },
            data:{
                labels: [],
                datasets: []
            },
            chartArray: [],
            ids:[]
        }
    },
    methods:{
        getChartData(){
                const companyId = this.company_id;
            var docRef = db.collection("companyAnalytics").doc(companyId).collection("widget9").doc("listing");
            docRef.get()
           .then(doc =>{
               if(doc.exists){
                  const data = doc.data();
                  this.chartArray[0] = data.PART1; 
                    this.chartArray[1] = data.PART2; 
                    this.chartArray[2] = data.PART3; 
                    this.chartArray[3] = data.PART4;  
                    this.chartArray[4] = data.PART5;    
                    this.chartArray[5] = data.PART6;  
               }
          
                this.loadChart();
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
        },
        loadChart(){
               this.data = {
                 labels: ['Neck', 'Wrist', 'Elbow','Back','Knee','General'],
                datasets: [{
                    data: this.chartArray,
                    backgroundColor: [
                        '#13cc43', 
                        '#f8b229', 
                        '#bb2528', 
                        'purple',
                        'teal',
                        'indigo',
                    ] ,
                }],
                
            }
                console.log(this.chartArray);
            }
        },
    components: {
        Chart
    },
    beforeMount(){
        this.getChartData()
    }
    
}

</script>

